
import { defineComponent, ref, onMounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage } from "element-plus"
import GrantModal from "./GrantModal.vue"
import { LotteryCoupon } from "@/store/modules/LotteryCouponModule"

export default defineComponent({
  components: {
    GrantModal
  },
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("抽赏优惠券列表", ["抽赏优惠券管理;lottery_coupons"])
    })

    const store = useStore()
    const tableData = ref<LotteryCoupon[]>([])

    const formData = ref({
      name: '',
      coupon_type: '',
      status: ''
    })

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    })

    const grantModalVisible = ref(false)
    const selectedCoupon = ref<LotteryCoupon | null>(null)

    const query = () => {
      store
        .dispatch(Actions.GET_LOTTERY_COUPONS, { ...formData.value, ...page.value })
        .then(() => {
          tableData.value = store.getters.currentLotteryCoupons
          page.value.totalResult = store.getters.currentLotteryCouponCount
        })
        .catch(() => {
          ElMessage.error('获取优惠券列表失败')
        })
    }

    query()

    const submitEvent = () => {
      page.value.currentPage = 1
      query()
    }

    const onPageChange = (e) => {
      page.value.currentPage = e.currentPage
      page.value.pageSize = e.pageSize
      query()
    }

    const onReset = () => {
      formData.value = {
        name: '',
        coupon_type: '',
        status: ''
      }
      page.value.currentPage = 1
      query()
    }

    const formatDate = (dateStr: string) => {
      if (!dateStr) return ''
      return dateStr.slice(0, 16).replace('T', ' ')
    }

    const openGrantModal = (coupon: LotteryCoupon) => {
      selectedCoupon.value = coupon
      grantModalVisible.value = true
    }

    const onGrantSuccess = () => {
      grantModalVisible.value = false
      query()
    }

    return {
      tableData,
      formData,
      submitEvent,
      page,
      onPageChange,
      onReset,
      formatDate,
      grantModalVisible,
      selectedCoupon,
      openGrantModal,
      onGrantSuccess
    }
  },
})
